import React from "react";
import Suggestions from "../Chat/Suggestions/Suggestions";
import XButton from "../../Widgets/ClosedWidget/XButton";
import { always } from "ramda";
import { createUseStyles } from "react-jss";
import defaultPromptStyles from "./PromptStyle";
import { makeStylesFromThemeAndCustomStyles } from "../../../lib/StyleFunctions";

export default ({
  text,
  onSuggestionClick,
  style,
  suggestions = [],
  onClose,
  customWidgetStyle,
}) => {
  const styles = createUseStyles(
    makeStylesFromThemeAndCustomStyles(
      style ? style : always(defaultPromptStyles),
      customWidgetStyle
    )
  )();
  return text ? (
    <div className={styles.prompt}>
      {styles.close ? (
        <XButton
          close={styles.close}
          onCloseClick={() => onClose({ text, suggestions })}
          aria-label="Close prompt bubble"
          title="Close prompt bubble"
        />
      ) : null}
      <div className={suggestions.length ? styles.text : ""}> {text} </div>
      {suggestions.length > 0 && (
        <Suggestions
          suggestions={suggestions}
          handleClick={onSuggestionClick}
        />
      )}
      <div className={styles.promptArrow} />
    </div>
  ) : null;
};
